import * as React from 'react';
import { SVGProps } from 'react';

const IconUserSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 1c4 0 5 1 5 4H1c0-3 1-4 5-4Z"
    />
  </svg>
);
export default IconUserSizeXs;
